/* eslint-env browser */
/* eslint no-plusplus: 0 */
import {
  createSlice, PayloadAction,
} from '@reduxjs/toolkit';
import initialState from './initialState';
import { backendApi } from '../../services/api';

const bachelorSlice = createSlice({
  name: 'bachelor',
  initialState,
  reducers: {
    setCongratulate(state, action: PayloadAction<ICongratulatePayload>) {
      const newState = state;
      newState.congratulate = action.payload.congratulate;
      newState.congratulateMoveIn = action.payload.moveIn;
      return newState;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      backendApi.endpoints.answer.matchFulfilled, // Matcher når mutation er succesfuld
      (state, action) => {
        if (action.payload.saved && action.payload.offerAccepted) {
          Object.assign(state, {
            congratulate: true,
            congratulateMoveIn: true,
          });
        }
      },
    );
  },
});

export const {
  setCongratulate,
} = bachelorSlice.actions;

export default bachelorSlice.reducer;
